export default __webpack_public_path__ + "static/media/alignment-horizontal-center.a0f3b7fb.svg";